package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.SignSymptomRelationType
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer

@Serializable
open class SignSymptomRelation(var id: String? = null){
	var signSymptomId: String? = null
	var signSymptomId2: String? = null
	var type: SignSymptomRelationType? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null
	var createdBy: String? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as SignSymptomRelation
		if (id != other.id) return false
		if (signSymptomId != other.signSymptomId) return false
		if (signSymptomId2 != other.signSymptomId2) return false
		if (type != other.type) return false
		if (createdOn != other.createdOn) return false
		if (createdBy != other.createdBy) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (signSymptomId?.hashCode() ?: 0)
		result = 31 * result + (signSymptomId2?.hashCode() ?: 0)
		result = 31 * result + (type?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		return result
	}

}
